import Header from "./header";
import Footer from "./footer";

interface IProps {
    children: React.ReactNode;
    hasSidebar?: boolean;
    hideFooter?: boolean;
    sidebarLayout?: 1 | 2;
    layout?: "app";
    hideHeader?: boolean;
}

const Layout = ({
    children,
    hasSidebar,
    hideFooter,
    sidebarLayout,
    hideHeader,
}: IProps) => {
    return (
        <>
            {!hideHeader && (
                <Header hasSidebar={hasSidebar} sidebarLayout={sidebarLayout} />
            )}
            {children}
            {!hideFooter && <Footer />}
        </>
    );
};

Layout.defaultProps = {
    hideFooter: false,
};

export default Layout;
